import React from 'react'
import PropTypes from 'prop-types'
import { Popover } from 'react-bootstrap'
/*
const styles = {
  position: 'absolute',
  backgroundColor: '#EEE',
  boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
  border: '1px solid #CCC',
}
*/
class ListSelector extends React.Component {
/*
  constructor(...args) {
    super(...args)
    this.state = { show: false }
  }
*/
  handleSelect = e => {
    console.log('select', e)
    //if (this.props.onSelect) this.props.onSelect(item)
  }

  render() {
    const { title, content } = this.props
    console.log(this.props)

    return (
      <Popover id='popover-content' title={title} >
        <ul className='list-group'>
          { content.map((item, i) => <li className='list-group-item' key={item} onClick={this.handleSelect}>{item}</li>) }
        </ul>
      </Popover>
    )
  }
}

ListSelector.defaultProps = {
  title: false,
  content: [],
}

ListSelector.propTypes = {
  title: PropTypes.string,
  content: PropTypes.array,
  onSelect: PropTypes.func
}

export default ListSelector



// WEBPACK FOOTER //
// ./src/components/widgets/ListSelector.js